import { HttpClient } from '@angular/common/http';
import { Injectable, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, catchError, map, tap } from 'rxjs';
import { environment } from '@env/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as FingerprintJS from '@fingerprintjs/fingerprintjs';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {

  hasInternetSubject = new BehaviorSubject<boolean>(true);
  consultor = new BehaviorSubject<any>(null);
  completeDeviceInfo: any = null;
  private onboardingData: WritableSignal<any> = signal({
  });

  constructor(private httpClient: HttpClient,
              private router: Router,
              private deviceService: DeviceDetectorService,
    ) {
      const phone = localStorage.getItem('phone');
      const consultorName = localStorage.getItem('consultorName');
      const qr = localStorage.getItem('qr');
      const user = localStorage.getItem('user');
      const agency = localStorage.getItem('agency');
      const data = {
        phone: phone,
        name: consultorName,
        user: user,
        agency: agency,
        qrImage: qr,
      };
      this.consultor.next(data);
     }

  getNewSession(consultor:any) {
    return this.httpClient.post(`${ environment.serverUrl }/checkSession`, {consultor});
  }

  setOnboardinData(onboardingData: any){
    this.onboardingData.set(onboardingData);
  }

  setValidateData(data: { code: string; message: string; type: string; data: { procedureId: number; expirationDate: string; creationDate: string; state: string; userId: number; identificationNumber: string; documentType: string; levelIdentity: number; transactionValidation: { validationId: number; validatorName: string; result: string; transactionValidationStatusId: number; transactionValidationStatus: string; }[]; documents: never[]; failedRedirectUrl: string; successRedirectUrl: string; data: string; userName: string; attribute: string; procedureType: number; originatorNames: string; originatorLastnames: string; }; traceId: string; }) {
    return this.httpClient.post(`${ environment.serverUrl }/setValidateData`, { data });
  }

  getOnboardingData(){
    return this.onboardingData();
  }

  setConsultor(internalCode: string,) {
    const session = localStorage.getItem('session');
    const deviceInfo = this.getDeviceInfo();

    return this.httpClient.post(`${ environment.serverUrl }/setConsultor`, {consultor:internalCode, session})
    .pipe(
      tap((response:any) => {
        this.consultor.next({
            phone: response.phone,
            name: response.name,
            user: response.user,
            qrImage:`${environment.serverUrl}/assets/qr/${ response.qrCode }`
        });
      }),
      tap(() => {
        FingerprintJS.load().then(fp => {
            fp.get().then(result => {
              const fingerprint = result.visitorId;
              this.completeDeviceInfo = {
                ...deviceInfo,
                fingerprint,
              };

              this.setDeviceData(this.completeDeviceInfo).subscribe({
                next: (response:any) => {
              },
              error: (error:any) => {
                console.error('Error', error);
              }});
            });
          });
      })
    )

  }

  getTypedPersonData() {
    return this.httpClient.post(`${ environment.serverUrl }/getTypedPersonData`, {});
  }

  getConsultorInfo(){
    return this.consultor.getValue();
  }

  getDeviceInfo(){
    return this.deviceService.getDeviceInfo();
  }

  getBalance() {
    return this.httpClient.post(`${ environment.serverUrl }/getBalance`, {});
  }

  setBalance(data: { incomeExtraActivity: number; outcome: number; assets: number; liabilities: number; }) {
    return this.httpClient.post(`${ environment.serverUrl }/setBalance`, data);
  }

  getForeign() {
    return this.httpClient.post(`${ environment.serverUrl }/getForeign`, {});
  }

  setForeign(value: any) {
    return this.httpClient.post(`${ environment.serverUrl }/setForeign`, value);
  }

  setForeningHasPublicJobManager(value:any) {
    return this.httpClient.post(`${ environment.serverUrl }/setForeningHasPublicJobManager`, value);
  }

  sendOTP() {
    return this.httpClient.post(`${ environment.serverUrl }/sendOTP`, { });
  }

  validateOTP(code: string) {
    return this.httpClient.post(`${ environment.serverUrl }/checkOTP`, { code });
  }

  getPrincipalActivityTypeId(){
    return this.httpClient.get(`${ environment.serverUrl }/getPrincipalActivityTypeId`);
  }

  getCategories(){
    return this.httpClient.get(`${environment.serverUrl}/app/listSavingCategory/getCategoryList`)
  }

  validateOnboardingTodayByIdentification(identification:string){
    return this.httpClient.post(`${ environment.serverUrl }/validateOnboardingTodayByIdentification`, {identification})
  }

  calculateQuota(quota: string | number) {
    return this.httpClient.post(`${environment.serverUrl}/app/contributions/calculateQuota`, {quota});
  }

  getConsultor() {
    return this.httpClient.post(`${ environment.serverUrl }/getConsultor`, {})
    .pipe(
      catchError((error: any) => {
        if(error.status === 0) {
          this.hasInternetSubject.next(false);
        }
        if (error.status === 401 || (error.status === 403)) {
          localStorage.clear();
          this.router.navigate(['/']);
          return this.getNewSession(null);
        }
        return error;
      }),
      tap((response: any) => {
        if(!!response.name) {
          localStorage.setItem('qr', `${environment.serverUrl}/assets/qr/${ response.qrCode }`);
          localStorage.setItem('phone', response.phone);
          localStorage.setItem('consultorName', response.name);
          localStorage.setItem('user', response.user);
          localStorage.setItem('agency', response.agency);

          this.consultor.next({
            phone: response.phone,
            name: response.name,
            user: response.user,
            agency: response.agency,
            qrImage: `${environment.serverUrl}/assets/qr/${ response.qrCode }`
          });

        }
      }),
      map((response: any) => {
        this.hasInternetSubject.next(true);
        return response;
      }),
    )
    ;
  }

  getCheckpoint(){
    return this.httpClient.get(`${environment.serverUrl}/getCheckpoint`)
  }

  setActiveServices(activeServices: string[]) {
    return this.httpClient.post(`${ environment.serverUrl }/setActiveServices`, {activeServices});
  }

  setDeviceData(deviceData: any) {
    return this.httpClient.post(`${ environment.serverUrl }/app/deviceCustomer/addDevice`, deviceData);
  }

  getServices() {
    return this.httpClient.post(`${ environment.serverUrl }/getActiveServices`, {})
    .pipe(
      catchError((error: any) => {
        if(error.status === 0) {
          this.hasInternetSubject.next(false);
        }
        if (error.status === 401 || (error.status === 403)) {
          localStorage.clear();
          this.router.navigate(['/']);
          return this.getNewSession(null);
        }
        return error;
      }),
      map((response: any) => {
        this.hasInternetSubject.next(true);
        return response;
      })
    )
    ;
  }

  //Validation Identification
  checkBlockIdentification(identification: number) {
    return this.httpClient.post(`${ environment.serverUrl }/checkIdentification`, {nIdentificacion: identification});
  }

  setTypedPersonData(identificationType: string | number, identification: string, email: string, phone: string, fullname: string, birthday: string | Date, nationalityId: string | number,) {
    return this.httpClient.post(`${ environment.serverUrl }/setTypedPersonData`,
      {identificationType, identification, email, phone, fullname, birthday, nationalityId}
    );
  }

  checkAddress(address: any) {
    return this.httpClient.post(`${ environment.serverUrl }/checkAddress`, {address});
  }

  setAddressData(addressData: any) {
    return this.httpClient.post(`${ environment.serverUrl }/setAddressData`, {addressData});
  }

  getAddressData() {
    return this.httpClient.post(`${ environment.serverUrl }/getAddressData`, {});
  }

  setPapData(papData: any) {
    return this.httpClient.post(`${ environment.serverUrl }/app/pap/addPap`, {papData});
  }

  showPapData() {
    return this.httpClient.get(`${ environment.serverUrl }/app/pap/showPap`);
  }

}
